import { useState, useEffect, useCallback } from 'react';
import { api } from '@/api/client';
import { getSocket } from './useRealtimeSync';
import { MESSENGER_UNREAD_INVALIDATE } from '@/constants/messengerEvents';

export function useMessengerUnreadTotal() {
  const [total, setTotal] = useState(0);

  const fetchTotal = useCallback(async () => {
    try {
      const { total_unread } = await api.messenger.getUnreadTotal();
      setTotal(total_unread);
    } catch {
      setTotal(0);
    }
  }, []);

  useEffect(() => {
    void fetchTotal();
  }, [fetchTotal]);

  useEffect(() => {
    const socket = getSocket();
    const onMessage = () => {
      void fetchTotal();
    };
    socket.on('messenger:message', onMessage);
    socket.on('messenger:messages_batch', onMessage);
    socket.on('messenger:read', onMessage);
    socket.on('messenger:thread_read', onMessage);
    socket.on('messenger:agent_chat_message', onMessage);
    socket.on('messenger:agent_chat_read', onMessage);
    return () => {
      socket.off('messenger:message', onMessage);
      socket.off('messenger:messages_batch', onMessage);
      socket.off('messenger:read', onMessage);
      socket.off('messenger:thread_read', onMessage);
      socket.off('messenger:agent_chat_message', onMessage);
      socket.off('messenger:agent_chat_read', onMessage);
    };
  }, [fetchTotal]);

  useEffect(() => {
    const onLocalRead = () => {
      void fetchTotal();
    };
    window.addEventListener(MESSENGER_UNREAD_INVALIDATE, onLocalRead);
    return () => window.removeEventListener(MESSENGER_UNREAD_INVALIDATE, onLocalRead);
  }, [fetchTotal]);

  return { totalUnread: total, refetch: fetchTotal };
}
